import { Component, Input, OnDestroy } from '@angular/core';
import { ApplicationQuery } from '@app/store/application/application.query';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
	standalone: false,
	selector: 'qe-progress-bar-step',
	templateUrl: './progress-bar-step.component.html',
	styleUrls: ['./progress-bar-step.component.scss'],
})
export class ProgressBarStepComponent implements OnDestroy {
	@Input() step!: number;
	@Input() label!: string;
	private readonly ngUnsubscribe$: Subject<boolean> = new Subject();

	private currentStep!: number;
	public get isActive(): boolean {
		return this.currentStep === this.step;
	}
	public get isCompleted(): boolean {
		return this.currentStep >= this.step;
	}

	constructor(private readonly appQueries: ApplicationQuery) {
		this.appQueries
			.workflowStep$()
			.pipe(takeUntil(this.ngUnsubscribe$))
			.subscribe(step => this.currentStep = step);
	}

	ngOnDestroy(): void {
		this.ngUnsubscribe$.next(true);
		this.ngUnsubscribe$.unsubscribe();
	}
}
